var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconModem40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.118 26.1992H5.77164C4.79321 26.1992 4 26.9458 4 27.8667V32.0352C4 32.9561 4.79321 33.7027 5.77164 33.7027H34.118C35.0965 33.7027 35.8897 32.9561 35.8897 32.0352V27.8667C35.8897 26.9458 35.0965 26.1992 34.118 26.1992Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3174 12.1309V26.1998",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3174 29.9521H15.2553",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3242 29.9521H30.2621",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6343 29.9521H25.5722",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5513 13.1916C15.8464 13.1916 16.8962 12.1418 16.8962 10.8468C16.8962 9.55178 15.8464 8.50195 14.5513 8.50195C13.2564 8.50195 12.2065 9.55178 12.2065 10.8468C12.2065 12.1418 13.2564 13.1916 14.5513 13.1916Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34304 8.37793C8.7826 9.20329 8.45508 10.1996 8.45508 11.2724C8.45508 12.3296 8.77311 13.3126 9.3187 14.1308",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99001 6.50293C5.17633 7.75261 4.70361 9.24462 4.70361 10.847C4.70361 12.4542 5.17915 13.9502 5.99719 15.2021",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7349 8.07617C20.2954 8.90153 20.6229 9.89789 20.6229 10.9707C20.6229 12.0279 20.3049 13.0109 19.7592 13.829",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0882 6.62695C23.9018 7.87663 24.3746 9.36865 24.3746 10.971C24.3746 12.5782 23.8991 14.0742 23.0811 15.3262",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconModem40);
export default __webpack_public_path__ + "static/media/pictogramBeaconModem40.41c4a5a8d012ec9c003d142605b2e765.svg";
export { ForwardRef as ReactComponent };